
<div class="main">
  <div class="droparea" (drop)="onDrop($event)" (dragover)="onDragover($event)">
    <p class="uploadHint" *ngIf="files.length<1">Dateien in dieses Feld ziehen</p>
    <div class="scrollArea" *ngIf="files.length>0">
      <app-fileUploadItem  #items *ngFor="let file of files" [file]="file"
      [title]="title"
      (setFileInfo)="onSetFileInfo($event)"
      (setDone)="removeFile($event)">
      </app-fileUploadItem>
    </div>
  </div>
</div>
<div class="buttonline" #buttonline>
  <div class="left">
    <span *ngIf="files.length>0">Verbleibend: {{files.length}} Dateien, {{getFileSizeTotal() | fileSize}}</span>
    <h2 *ngIf="files.length==0">{{getFiletypesDescription()}}</h2>
  </div>
  <div class="right">
    <button mat-button  title="Datei-Auswahl" (click)="onUpload($event)"><i class="material-icons">upload</i>Hochladen</button>
    <button mat-button  title="alle abbrechen" (click)="onClearAll($event)" [disabled]="files.length<1"><i class="material-icons">clear</i>Abbrechen</button>
  </div>
</div>
<input ng2FileSelect type="file" (change)="selectFiles($event)" #fileInput hidden="hidden" [multiple]="true" />
